import { LockKeyhole, Sprout } from "lucide-react";
import { type FormEvent, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { supabase } from "../lib/supabase";

export function LoginPage() {
  const auth = useAuth();
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  if (auth.demo || auth.session) return <Navigate to="/" replace />;
  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!supabase) return;
    setLoading(true);
    setError(null);
    const form = new FormData(event.currentTarget);
    const { error: signError } = await supabase.auth.signInWithPassword({
      email: String(form.get("email")),
      password: String(form.get("password")),
    });
    if (signError) {
      setError("Login inválido ou usuário ainda não autorizado.");
      setLoading(false);
    }
  };
  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-brand">
          <div className="brand-mark">
            <Sprout size={24} />
          </div>
          <div>
            <strong>Estufa</strong>
            <span>Seed Factory</span>
          </div>
        </div>
        <div className="auth-copy">
          <span className="eyebrow">Acesso privado</span>
          <h1>Entre no centro operacional</h1>
          <p>Esta área guarda métricas, decisões e inteligência do portfólio.</p>
        </div>
        <form className="form-stack" onSubmit={(event) => void submit(event)}>
          <label>
            Email
            <input name="email" type="email" autoComplete="email" required />
          </label>
          <label>
            Senha
            <input name="password" type="password" autoComplete="current-password" required />
          </label>
          {error ? <p className="form-error">{error}</p> : null}
          <button type="submit" className="primary-button auth-submit" disabled={loading}>
            <LockKeyhole size={17} />
            {loading ? "Entrando…" : "Entrar"}
          </button>
        </form>
      </div>
    </div>
  );
}
